import { SwageazyInventoryFilters } from "../../../models/SwageazyInventory/SwageazyInventoryFilter";
import SwageazyInventoryAPI from "../api/SwageazyInventoryAPI";
import OrderProductsVariantsAPI from "../api/OrderProductsVariantsAPI";
import {
  SwageazyInventoryDetails,
  SwageazyInventoryInwardRequestFormData,
  SwageazyInventoryOutwardRequestFormData,
  SwageazyInventorySampleReturnRequestFormData,
  SwageazyInventorySkuLineItem,
  SampleSirReturnOption,
  SwageazyInventoryProductRequestVariant,
  SwageazyInventoryResolveBoxesProduct,
  QuantityDetails,
  PurchaseOrderProduct,
  PurchaseOrderProductDetails,
  BlockedQuantityDetailsModel,
  ProductStockDetails,
  SwageazyInventoryVariantStockShortage,
  SwageazyInventoryBoxTransferFormData,
  BoxTransferStockLine,
  BoxTransferRequest,
  BoxTransferVariantPrefill,
  SwageazyInventoryRackTransferFormData,
  RackTransferRequest,
  RackTransferVariantPrefill,
  CreatedRackResult,
  WarehouseRackOption,
} from "../../../models/SwageazyInventory/SwageazyInventory";
import { WarehouseBoxOption } from "../../../models/Warehouse/Warehouse";
import {
  PurchaseRequestProductRequestBody,
  ProductVariantData,
  PurchaseRequestSkuVariant,
} from "../../../models/PurchaseRequest/PurchaseRequestProductRequestBody";
import { ProjectSourcingProduct } from "../../../models/ProjectManagement/ProjectSourcingProduct";
import { action, makeObservable, observable, runInAction } from "mobx";
import { PurchaseRequestBody } from "../../../models/PurchaseRequest/PurchaseRequestBody";
import { PurchaseOrders } from "../../../models/SwageazyInventory/SwageazyInventory";
import { buildSkuWarehouseLocations } from "../helpers/orderInventoryAvailability.helper";
import { FilterValue } from "../../../models/Filters/FilterValue";
import { PurhcaseRequestDetails } from "../../../models/PurchaseRequest/PurchaseRequestDetails";
import { APIResponse } from "../../../models/NetworkResponse";

/** Totals per product actually submitted, used to refresh the listing. */
export interface SwageazyInventorySubmittedProductTotal {
  product_id: number;
  quantity: number;
}

export class SwageazyInventoryStore {
  swageazyInventoryAPI: SwageazyInventoryAPI;
  orderProductsVariantsAPI: OrderProductsVariantsAPI;
  purchaseRequestDetail: PurhcaseRequestDetails | null;
  purchaseRequestDetailsList: PurhcaseRequestDetails[];
  swageazyInventoryListingResponse: SwageazyInventoryDetails[];
  purchaseRequestFormData: PurchaseRequestBody;
  inwardRequestFormData: SwageazyInventoryInwardRequestFormData;
  outwardRequestFormData: SwageazyInventoryOutwardRequestFormData;
  sampleReturnRequestFormData: SwageazyInventorySampleReturnRequestFormData | null;
  boxTransferFormData: SwageazyInventoryBoxTransferFormData;
  rackTransferFormData: SwageazyInventoryRackTransferFormData;
  warehouseRacks: WarehouseRackOption[];
  warehouseBoxes: WarehouseBoxOption[];
  sampleReturnSirOptions: SampleSirReturnOption[];
  productStockDetails: ProductStockDetails | null;
  prVariantStockShortages: SwageazyInventoryVariantStockShortage[];
  isValidatingPrInventoryStock: boolean;
  isPrInventoryResolved: boolean;
  blockStockDetailsResponce: BlockedQuantityDetailsModel | null;
  limit: number;
  total_count: number;
  total_pages: number;
  filterCount: number;
  isLoading: boolean;
  isFetchingData: boolean;
  isBoxTransferLoading: boolean;
  isRackTransferLoading: boolean;
  isRackTransferLookupLoading: boolean;
  /** Invalidates in-flight box-transfer loads when form is reset/closed/reopened. */
  private boxTransferLoadSeq: number;
  /** Invalidates in-flight rack-transfer warehouse loads. */
  private rackTransferLoadSeq: number;
  selectedProduct: number | null;
  selectedProductImages: string[];
  popupState: {
    openFilter: boolean;
    openImageGallery: boolean;
    openCreatePrPopup: boolean;
    openInwardPopup: boolean;
    openOutwardPopup: boolean;
    openSampleReturnPopup: boolean;
    openBoxTransferPopup: boolean;
    openRackTransferPopup: boolean;
    InventoryStockQuantityDetailsPopup: boolean;
    openvendorPopup: boolean;
  };
  poProducts: PurchaseOrderProduct[];
  poSearchResults: FilterValue[];
  orderProducts: PurchaseOrderProduct[];
  orderSearchResults: FilterValue[];
  products: ProjectSourcingProduct[];
  purchaseRequestProducts: PurchaseRequestProductRequestBody[];
  selectedProductVariants: Map<number, ProductVariantData[]>;
  selectedSkuVariants: Map<number, PurchaseRequestSkuVariant[]>;
  availableVariantOptions: { [key: string]: FilterValue[] };
  apiTimer: NodeJS.Timeout | null;
  hoverIndex: number | null;
  productSearchText: string;

  constructor() {
    this.swageazyInventoryAPI = new SwageazyInventoryAPI();
    this.orderProductsVariantsAPI = new OrderProductsVariantsAPI();
    this.swageazyInventoryListingResponse = [];
    this.purchaseRequestDetail = null;
    this.purchaseRequestDetailsList = [];
    this.limit = 0;
    this.total_count = 0;
    this.total_pages = 0;
    this.filterCount = 0;
    this.isLoading = false;
    this.isFetchingData = false;
    this.isBoxTransferLoading = false;
    this.isRackTransferLoading = false;
    this.isRackTransferLookupLoading = false;
    this.boxTransferLoadSeq = 0;
    this.rackTransferLoadSeq = 0;
    this.selectedProduct = null;
    this.selectedProductImages = [];
    this.purchaseRequestFormData = {};
    this.inwardRequestFormData = {};
    this.outwardRequestFormData = {};
    this.sampleReturnRequestFormData = null;
    this.boxTransferFormData = {};
    this.rackTransferFormData = {};
    this.warehouseRacks = [];
    this.warehouseBoxes = [];
    this.sampleReturnSirOptions = [];
    this.prVariantStockShortages = [];
    this.isValidatingPrInventoryStock = false;
    this.isPrInventoryResolved = false;
    this.blockStockDetailsResponce = null;
    this.popupState = {
      openFilter: false,
      openImageGallery: false,
      openCreatePrPopup: false,
      openInwardPopup: false,
      openOutwardPopup: false,
      openSampleReturnPopup: false,
      openBoxTransferPopup: false,
      openRackTransferPopup: false,
      InventoryStockQuantityDetailsPopup: false,
      openvendorPopup: false,
    };
    this.poProducts = [];
    this.poSearchResults = [];
    this.orderProducts = [];
    this.orderSearchResults = [];
    this.products = [];
    this.purchaseRequestProducts = [];
    this.selectedProductVariants = new Map();
    this.selectedSkuVariants = new Map();
    this.availableVariantOptions = {};
    this.productStockDetails = null;
    this.apiTimer = null;
    this.hoverIndex = null;
    this.productSearchText = "";

    makeObservable(this, {
      swageazyInventoryListingResponse: observable,
      purchaseRequestDetail: observable,
      purchaseRequestDetailsList: observable,
      getPurchaseRequestDetailByPOId: action,
      getPurchaseRequestDetailsByOrderIdAndProductId: action,
      selectPurchaseRequestDetail: action,
      limit: observable,
      total_count: observable,
      total_pages: observable,
      filterCount: observable,
      isLoading: observable,
      isFetchingData: observable,
      isBoxTransferLoading: observable,
      isRackTransferLoading: observable,
      isRackTransferLookupLoading: observable,
      selectedProduct: observable,
      selectedProductImages: observable,
      products: observable,
      purchaseRequestProducts: observable,
      selectedProductVariants: observable,
      selectedSkuVariants: observable,
      setSelectedSkuVariants: action,
      availableVariantOptions: observable,
      productStockDetails: observable,
      prVariantStockShortages: observable,
      isValidatingPrInventoryStock: observable,
      isPrInventoryResolved: observable,
      blockStockDetailsResponce: observable,
      purchaseRequestFormData: observable,
      inwardRequestFormData: observable,
      outwardRequestFormData: observable,
      sampleReturnRequestFormData: observable,
      boxTransferFormData: observable,
      rackTransferFormData: observable,
      warehouseRacks: observable,
      warehouseBoxes: observable,
      sampleReturnSirOptions: observable,
      poProducts: observable,
      poSearchResults: observable,
      orderProducts: observable,
      orderSearchResults: observable,
      apiTimer: observable,
      popupState: observable,
      hoverIndex: observable,
      productSearchText: observable,
      setProductSearchText: action,
      setIsLoading: action,
      getSwageazyInventoryListing: action,
      managePopup: action,
      setSelectedProductImages: action,
      setPurchaseRequestFormData: action,
      setInwardRequestFormData: action,
      setSampleReturnRequestFormData: action,
      setOutwardRequestFormData: action,
      updateInwardRequestFormData: action,
      loadInwardSkuItemsFromPo: action,
      loadOutwardSkuItemsFromPo: action,
      loadSampleReturnSkuItemsFromOrder: action,
      loadSampleReturnSirOptions: action,
      initSampleReturnFromSir: action,
      updateInwardSkuItem: action,
      updateOutwardSkuItem: action,
      setOutwardSkuItemsSelected: action,
      setSampleReturnSkuItemsSelected: action,
      updateOutwardQuantityDetail: action,
      clearOutwardQuantityDetails: action,
      resolveOutwardBoxes: action,
      updateSampleReturnSkuItem: action,
      resetInwardRequestFormData: action,
      resetSampleReturnRequestFormData: action,
      resetOutwardRequestFormData: action,
      resetCreatePurchaseRequestState: action,
      clearPrVariantStockShortages: action,
      resetPrInventoryResolution: action,
      validateSelectedSkuVariantsAgainstSwageazyInventory: action,
      setPoProducts: action,
      setPoSearchResults: action,
      setOrderProducts: action,
      setOrderSearchResults: action,
      setAvailableVariantOptions: action,
      setApiTimer: action,
      clearApiTimer: action,
      setHoverIndex: action,
      updateInventoryListingAfterOutward: action,
      updateInventoryListingAfterSampleReturn: action,
      downloadSwageazyInventoryReport: action,
      uploadInventoryVariantSkuCsv: action,
      clearPurchaseRequestDetail: action,
    });
  }

  getSwageazyInventoryListing = async (filters: SwageazyInventoryFilters) => {
    try {
      const response =
        await this.swageazyInventoryAPI.getSwageazyInventoryListing(filters);
      this.swageazyInventoryListingResponse =
        response.list as SwageazyInventoryDetails[];
      this.limit = response.limit;
      this.total_count = response.total_count;
      this.total_pages = response.total_pages;
    } catch (error) {
      throw error;
    }
  };

  downloadSwageazyInventoryReport = async (
    filters: SwageazyInventoryFilters,
  ) => {
    try {
      const response =
        await this.swageazyInventoryAPI.downloadSwageazyInventoryReport(
          filters,
        );
      return response;
    } catch (error) {
      throw error;
    }
  };

  uploadInventoryVariantSkuCsv = async (file: File) => {
    try {
      const response =
        await this.swageazyInventoryAPI.uploadInventoryVariantSkuCsv(file);
      return response;
    } catch (error) {
      throw error;
    }
  };

  fetchPurchaseOrderNumbers = async (searchText: string) => {
    try {
      const response =
        await this.swageazyInventoryAPI.getPurchaseOrderNumbers(searchText);
      return response;
    } catch (error) {
      throw error;
    }
  };

  createSwageazyInventoryPurchaseRequest = async () => {
    try {
      const transformedData = {
        ...this.purchaseRequestFormData,
        pr_products: this.purchaseRequestFormData.pr_products?.map(
          (product) => {
            const { id, ...rest } = product;
            return {
              ...rest,
              product_id: id,
            };
          },
        ),
      };
      const response =
        await this.swageazyInventoryAPI.createSwageazyInventoryPurchaseRequest(
          transformedData,
        );
      return response;
    } catch (error) {
      throw error;
    }
  };

  /** Rows with a received/returned quantity entered, grouped by product. */
  private groupSkuItemsByProduct = (
    skuItems: SwageazyInventorySkuLineItem[],
  ): Map<number, SwageazyInventorySkuLineItem[]> => {
    const grouped = new Map<number, SwageazyInventorySkuLineItem[]>();
    skuItems
      .filter((item) => Number(item.quantity) > 0)
      .forEach((item) => {
        const existing = grouped.get(item.product_id);
        if (existing) {
          existing.push(item);
        } else {
          grouped.set(item.product_id, [item]);
        }
      });
    return grouped;
  };

  private toRequestVariant = (
    item: SwageazyInventorySkuLineItem,
  ): SwageazyInventoryProductRequestVariant => {
    const variant: SwageazyInventoryProductRequestVariant = {
      sku: item.sku,
      quantity: item.quantity,
      quantity_rejected: item.quantity_rejected ?? 0,
      rejection_reason: item.rejection_reason ?? "",
    };
    if (item.expiry_date) {
      variant.expiry_date = item.expiry_date;
    }
    return variant;
  };

  /**
   * Submits the inward via the existing credit API — one call per product
   * that has at least one SKU with a received quantity. SKUs are never
   * generated here; they come from the PR.
   */
  createSwageazyInventoryInwardTransfer = async (): Promise<
    SwageazyInventorySubmittedProductTotal[]
  > => {
    try {
      const { images, sku_items, product_id, variants, ...formData } =
        this.inwardRequestFormData;

      const grouped = this.groupSkuItemsByProduct(sku_items || []);
      if (grouped.size === 0) {
        throw new Error(
          "Enter a received quantity for at least one SKU before submitting.",
        );
      }

      const submittedTotals: SwageazyInventorySubmittedProductTotal[] = [];

      for (const [productId, items] of Array.from(grouped.entries())) {
        const payload: SwageazyInventoryInwardRequestFormData = {
          ...formData,
          product_id: productId,
          variants: items.map(this.toRequestVariant),
        };

        await this.swageazyInventoryAPI.createSwageazyInventoryInwardTransfer(
          payload,
        );

        submittedTotals.push({
          product_id: productId,
          quantity: items.reduce(
            (sum, item) => sum + Number(item.quantity || 0),
            0,
          ),
        });
      }

      return submittedTotals;
    } catch (error) {
      throw error;
    }
  };

  /**
   * Resolves warehouse boxes for requested SKU quantities, then submits a
   * single `/debit` call with the (optionally lowered) quantity_details.
   */
  createSwageazyInventoryOutwardTransfer = async (): Promise<
    SwageazyInventorySubmittedProductTotal[]
  > => {
    try {
      const formData = this.outwardRequestFormData;
      const poId = formData.po_id;
      const warehouseId = formData.warehouse_id
        ? String(formData.warehouse_id)
        : undefined;

      if (!poId) {
        throw new Error("Please select a valid PO Number.");
      }
      if (!warehouseId || warehouseId === "-1") {
        throw new Error("Please select a valid Warehouse.");
      }

      const quantityDetails = (formData.quantity_details || []).filter(
        (detail) => Number(detail.quantity) > 0,
      );

      if (quantityDetails.length === 0) {
        throw new Error(
          "Resolve boxes and keep at least one quantity before submitting.",
        );
      }

      for (const detail of quantityDetails) {
        if (!detail.product_id || !detail.sku || !detail.box_id) {
          throw new Error(
            "Each debit line must include product, SKU, and box ID.",
          );
        }
        if (
          detail.max_quantity !== undefined &&
          Number(detail.quantity) > Number(detail.max_quantity)
        ) {
          throw new Error(
            `Quantity for SKU "${detail.sku}" in box "${detail.box_id}" cannot exceed available stock of ${detail.max_quantity}.`,
          );
        }
      }

      await this.swageazyInventoryAPI.createSwageazyInventoryOutwardTransfer({
        po_id: poId,
        warehouse_id: warehouseId,
        quantity_details: quantityDetails.map(
          ({ product_id, sku, box_id, quantity }) => ({
            product_id,
            sku,
            box_id,
            quantity: Number(quantity),
          }),
        ),
      });

      const totalsByProduct = new Map<number, number>();
      quantityDetails.forEach((detail) => {
        const current = totalsByProduct.get(detail.product_id) || 0;
        totalsByProduct.set(
          detail.product_id,
          current + Number(detail.quantity || 0),
        );
      });

      return Array.from(totalsByProduct.entries()).map(
        ([product_id, quantity]) => ({
          product_id,
          quantity,
        }),
      );
    } catch (error) {
      throw error;
    }
  };

  /**
   * Calls `/debit/resolve-boxes` for selected SKUs that have an outward qty.
   * Populates `quantity_details` (1 row per SKU + box). Qty can later be
   * lowered but not increased above the resolved amount.
   */
  resolveOutwardBoxes = async () => {
    try {
      const formData = this.outwardRequestFormData;
      const poId = formData.po_id;
      const warehouseId = formData.warehouse_id
        ? String(formData.warehouse_id)
        : undefined;

      if (!poId) {
        throw new Error("Please select a valid PO Number.");
      }
      if (!warehouseId || warehouseId === "-1") {
        throw new Error("Please select a valid Warehouse.");
      }

      const productsMap = new Map<number, SwageazyInventoryResolveBoxesProduct>();
      (formData.sku_items || [])
        .filter(
          (item) =>
            Boolean(item.selected) &&
            Number(item.quantity) > 0 &&
            Boolean(item.sku),
        )
        .forEach((item) => {
          const existing = productsMap.get(item.product_id);
          const variant = {
            sku: item.sku,
            quantity: Number(item.quantity),
            quantity_rejected: 0,
            rejection_reason: "",
          };
          if (existing) {
            existing.variants.push(variant);
          } else {
            productsMap.set(item.product_id, {
              product_id: item.product_id,
              variants: [variant],
            });
          }
        });

      const products = Array.from(productsMap.values());
      if (products.length === 0) {
        throw new Error(
          "Select at least one SKU and enter an outward quantity before resolving boxes.",
        );
      }

      const result = await this.swageazyInventoryAPI.resolveOutwardBoxes({
        po_id: poId,
        warehouse_id: warehouseId,
        warehouse_name: formData.warehouse_name,
        products,
      });

      const quantityDetails: QuantityDetails[] = (
        result?.quantity_details || []
      ).map((detail) => ({
        product_id: detail.product_id,
        sku: detail.sku,
        box_id: detail.box_id,
        quantity: Number(detail.quantity) || 0,
        max_quantity: Number(detail.quantity) || 0,
      }));

      if (quantityDetails.length === 0) {
        throw new Error(
          "No boxes could be resolved for the requested quantities.",
        );
      }

      runInAction(() => {
        this.outwardRequestFormData = {
          ...this.outwardRequestFormData,
          quantity_details: quantityDetails,
        };
      });

      return quantityDetails;
    } catch (error) {
      runInAction(() => {
        this.outwardRequestFormData = {
          ...this.outwardRequestFormData,
          quantity_details: [],
        };
      });
      throw error;
    }
  };

  updateInventoryListingAfterOutward = (
    productId: number,
    totalQuantity: number,
    lastUpdatedBy: string,
  ) => {
    runInAction(() => {
      this.swageazyInventoryListingResponse.forEach((item) => {
        if (item.id === productId) {
          item.quantity = item.quantity - totalQuantity;
          item.blocked_quantity = item.blocked_quantity - totalQuantity;
          item.last_updated_by = lastUpdatedBy;
          item.last_updated_at = new Date().toISOString();
        }
      });
    });
  };

  updateInventoryListingAfterSampleReturn = (
    productId: number,
    totalQuantity: number,
    lastUpdatedBy: string,
  ) => {
    runInAction(() => {
      this.swageazyInventoryListingResponse.forEach((item) => {
        if (item.id === productId) {
          item.quantity = item.quantity + totalQuantity;
          item.last_updated_by = lastUpdatedBy;
          item.last_updated_at = new Date().toISOString();
        }
      });
    });
  };

  /**
   * Submits the sample return via the existing return API — one call per
   * product that has at least one SKU with a returned quantity. SKUs come
   * from the order; nothing is generated here.
   */
  sampleReturn = async (): Promise<
    SwageazyInventorySubmittedProductTotal[]
  > => {
    try {
      const { sku_items, product_id, variants, ...formData } = (this
        .sampleReturnRequestFormData ||
        {}) as SwageazyInventorySampleReturnRequestFormData;

      const grouped = this.groupSkuItemsByProduct(
        (sku_items || []).filter((item) => Boolean(item.selected)),
      );
      if (grouped.size === 0) {
        throw new Error(
          "Select at least one SKU and enter a returned quantity before submitting.",
        );
      }

      const submittedTotals: SwageazyInventorySubmittedProductTotal[] = [];

      for (const [productId, items] of Array.from(grouped.entries())) {
        const payload: SwageazyInventorySampleReturnRequestFormData = {
          ...formData,
          product_id: productId,
          variants: items.map(this.toRequestVariant),
        };

        await this.swageazyInventoryAPI.sampleReturn(payload);

        submittedTotals.push({
          product_id: productId,
          quantity: items.reduce(
            (sum, item) => sum + Number(item.quantity || 0),
            0,
          ),
        });
      }

      return submittedTotals;
    } catch (error) {
      throw error;
    }
  };

  generateBoxId = async (
    current_rack: string,
    warehouse_id: string,
  ): Promise<string | null> => {
    try {
      const response = await this.swageazyInventoryAPI.generateBoxId(
        current_rack,
        warehouse_id,
      );
      return response?.result?.id ? String(response.result.id) : null;
    } catch (error) {
      throw error;
    }
  };

  BlockedQuantityDetails = async (
    po_id: number,
    product_id: number,
    warehouse_id: number | string,
  ) => {
    try {
      const response: BlockedQuantityDetailsModel =
        await this.swageazyInventoryAPI.BlockedQuantityDetails(
          po_id,
          product_id,
          warehouse_id,
        );

      runInAction(() => {
        this.blockStockDetailsResponce = response;
      });

      if (response && response.boxes && Array.isArray(response.boxes)) {
        return response.boxes;
      } else {
        return [];
      }
    } catch (error) {
      runInAction(() => {
        this.blockStockDetailsResponce = null;
      });
      throw error;
    }
  };

  clearPrVariantStockShortages = () => {
    runInAction(() => {
      this.prVariantStockShortages = [];
      this.isValidatingPrInventoryStock = false;
      this.isPrInventoryResolved = false;
    });
  };

  resetPrInventoryResolution = () => {
    this.clearPrVariantStockShortages();
  };

  validateSelectedSkuVariantsAgainstSwageazyInventory = async (
    warehouseId: string,
    variants: PurchaseRequestSkuVariant[],
  ): Promise<boolean> => {
    const selectedWarehouseId = String(warehouseId || "").trim();
    if (!selectedWarehouseId || variants.length === 0) {
      runInAction(() => {
        this.prVariantStockShortages = [];
        this.isValidatingPrInventoryStock = false;
        this.isPrInventoryResolved = false;
      });
      return false;
    }

    const requestedBySku = new Map<
      string,
      {
        product_id: number;
        product_name: string;
        variant_name: string;
        sku: string;
        requested_quantity: number;
      }
    >();

    variants.forEach((variant) => {
      const sku = String(variant.sku || "").trim();
      const productId = Number(variant.product_id);
      if (!sku || !productId) return;

      const key = `${productId}::${sku.toUpperCase()}`;
      const existing = requestedBySku.get(key);
      const requestedQuantity = Number(variant.quantity || 0);
      if (existing) {
        existing.requested_quantity += requestedQuantity;
        return;
      }

      requestedBySku.set(key, {
        product_id: productId,
        product_name: variant.product_name || `Product #${productId}`,
        variant_name: variant.title || sku,
        sku,
        requested_quantity: requestedQuantity,
      });
    });

    if (requestedBySku.size === 0) {
      runInAction(() => {
        this.prVariantStockShortages = [];
        this.isValidatingPrInventoryStock = false;
        this.isPrInventoryResolved = false;
      });
      return false;
    }

    runInAction(() => {
      this.isValidatingPrInventoryStock = true;
      this.prVariantStockShortages = [];
    });

    try {
      const uniqueProductIds = Array.from(
        new Set(
          Array.from(requestedBySku.values()).map((item) => item.product_id),
        ),
      );
      const stockDetailsList = await Promise.all(
        uniqueProductIds.map((productId) =>
          this.swageazyInventoryAPI.getProductStockDetails(productId),
        ),
      );
      const stockByProductId = new Map(
        uniqueProductIds.map((productId, index) => [
          productId,
          stockDetailsList[index],
        ]),
      );

      const shortages: SwageazyInventoryVariantStockShortage[] = [];
      requestedBySku.forEach((item) => {
        const stockDetails = stockByProductId.get(item.product_id);
        const variantsStock = stockDetails?.variants_stock;
        const skuKey = item.sku.toUpperCase();
        const skuExists = (variantsStock ?? []).some(
          (row) =>
            String(row.sku || "")
              .trim()
              .toUpperCase() === skuKey,
        );
        const warehouseStock = buildSkuWarehouseLocations(
          item.sku,
          variantsStock,
        ).find(
          (location) =>
            String(location.warehouse_id) === selectedWarehouseId,
        );
        const availableQuantity = Number(warehouseStock?.quantity ?? 0);

        if (availableQuantity >= item.requested_quantity) return;

        shortages.push({
          product_id: item.product_id,
          product_name: item.product_name,
          variant_name: item.variant_name,
          sku: item.sku,
          requested_quantity: item.requested_quantity,
          available_quantity: availableQuantity,
          reason: skuExists
            ? "Insufficient stock in the selected warehouse"
            : "Variant unavailable in Swageazy inventory",
        });
      });

      runInAction(() => {
        this.prVariantStockShortages = shortages;
        this.isValidatingPrInventoryStock = false;
        this.isPrInventoryResolved = shortages.length === 0;
      });

      return shortages.length === 0;
    } catch (error) {
      runInAction(() => {
        this.isValidatingPrInventoryStock = false;
        this.prVariantStockShortages = [];
        this.isPrInventoryResolved = false;
      });
      throw error;
    }
  };

  getProductStockDetails = async (product_id: number) => {
    try {
      const response =
        await this.swageazyInventoryAPI.getProductStockDetails(product_id);
      if (response) {
        const result = response as ProductStockDetails;
        runInAction(() => {
          this.productStockDetails = {
            total_stock: result.total_stock || [],
            variants_stock: result.variants_stock || [],
            blocked_stock: result.blocked_stock || [],
          };
        });
      }
      return response;
    } catch (error) {
      throw error;
    }
  };

  //from bellow update or clear function

  managePopup = (
    popup: keyof typeof this.popupState,
    action: "open" | "close",
  ) => {
    runInAction(() => {
      if (action === "open") {
        this.popupState[popup] = true;
      } else {
        this.popupState[popup] = false;
      }
    });
  };

  setIsLoading = (isLoading: boolean) => {
    runInAction(() => {
      this.isLoading = isLoading;
    });
  };

  setApiTimer = (timer: NodeJS.Timeout) => {
    runInAction(() => {
      this.apiTimer = timer;
    });
  };

  clearApiTimer = () => {
    if (this.apiTimer) {
      clearTimeout(this.apiTimer);
      this.apiTimer = null;
    }
  };

  setHoverIndex = (index: number | null) => {
    runInAction(() => {
      this.hoverIndex = index;
    });
  };

  setSelectedProductImages = (productId: number, images: string[]) => {
    runInAction(() => {
      this.selectedProduct = productId;
      this.selectedProductImages = images;
    });
  };

  setAvailableVariantOptions = (options: { [key: string]: FilterValue[] }) => {
    runInAction(() => {
      this.availableVariantOptions = options;
    });
  };

  setPoProducts = (products: PurchaseOrderProduct[]) => {
    runInAction(() => {
      this.poProducts = products;
    });
  };

  setPoSearchResults = (results: FilterValue[]) => {
    runInAction(() => {
      this.poSearchResults = results;
    });
  };

  setOrderProducts = (products: PurchaseOrderProduct[]) => {
    runInAction(() => {
      this.orderProducts = products;
    });
  };

  setOrderSearchResults = (results: FilterValue[]) => {
    runInAction(() => {
      this.orderSearchResults = results;
    });
  };

  updateInwardRequestFormData = (
    field: keyof SwageazyInventoryInwardRequestFormData,
    value: string | number | null | string[] | File[] | undefined,
  ) => {
    runInAction(() => {
      if (field && value !== undefined) {
        Object.assign(this.inwardRequestFormData, { [field]: value || null });
      }
    });
  };

  getPurchaseOrderNumbers = async (searchText: string) => {
    try {
      const response = await this.fetchPurchaseOrderNumbers(searchText);
      if (response) {
        let purchaseOrders: PurchaseOrders[] = [];
        const result = response as PurchaseOrderProductDetails;

        if (result.purchase_orders && Array.isArray(result.purchase_orders)) {
          purchaseOrders = result.purchase_orders;
        } else if (Array.isArray(response)) {
          purchaseOrders = response as PurchaseOrders[];
        }

        runInAction(() => {
          this.poSearchResults = purchaseOrders.map((po: PurchaseOrders) => ({
            id: String(po.po_id),
            value: String(po.po_id),
          }));
        });
      }
      return [];
    } catch (error) {
      throw error;
    }
  };

  getPurchaseRequestDetailByPOId = async (poId: number) => {
    try {
      const response =
        await this.swageazyInventoryAPI.getPurchaseRequestDetailByPOId(poId);
      runInAction(() => {
        this.purchaseRequestDetail = response;
      });
    } catch (error: any) {
      throw error;
    }
  };

  /**
   * Loads every product + SKU on the PO (via its PR) into the inward form.
   * Prefers the PR's sku_variants; falls back to legacy product rows that
   * already carry a SKU.
   */
  loadInwardSkuItemsFromPo = async (poId: number) => {
    try {
      await this.getPurchaseRequestDetailByPOId(poId);
      const detail = this.purchaseRequestDetail;

      let skuItems: SwageazyInventorySkuLineItem[] = [];

      if (detail?.sku_variants?.length) {
        skuItems = detail.sku_variants.map((variant) => ({
          product_id: variant.product_id,
          product_name:
            variant.product_name?.trim() || `Product #${variant.product_id}`,
          sku: variant.sku,
          title: variant.title,
          expected_quantity: variant.quantity,
        }));
      } else if (detail?.products?.length) {
        skuItems = detail.products
          .filter((product) => Boolean(product.sku))
          .map((product) => ({
            product_id: product.product_id,
            product_name: product.product_name,
            sku: product.sku as string,
            title: product.product_name,
            expected_quantity: product.quantity,
          }));
      }

      runInAction(() => {
        const poWarehouseId = detail?.warehouse_id
          ? String(detail.warehouse_id)
          : undefined;
        const poWarehouseName = detail?.warehouse_identifier
          ? String(detail.warehouse_identifier)
          : poWarehouseId;

        if (poWarehouseId) {
          this.inwardRequestFormData = {
            ...this.inwardRequestFormData,
            sku_items: skuItems,
            warehouse_id: poWarehouseId,
            warehouse_name: poWarehouseName,
            current_rack: undefined,
            box_id: undefined,
          };
        } else {
          this.inwardRequestFormData = {
            ...this.inwardRequestFormData,
            sku_items: skuItems,
            warehouse_id: undefined,
            warehouse_name: undefined,
            current_rack: undefined,
            box_id: undefined,
          };
        }
      });

      return skuItems;
    } catch (error) {
      runInAction(() => {
        this.inwardRequestFormData = {
          ...this.inwardRequestFormData,
          sku_items: [],
        };
      });
      throw error;
    }
  };

  /**
   * Loads every product + SKU on the PO (via its PR) into the outward form.
   * Prefers the PR's sku_variants; falls back to legacy product rows that
   * already carry a SKU.
   */
  loadOutwardSkuItemsFromPo = async (poId: number) => {
    try {
      await this.getPurchaseRequestDetailByPOId(poId);
      const detail = this.purchaseRequestDetail;

      let skuItems: SwageazyInventorySkuLineItem[] = [];

      if (detail?.sku_variants?.length) {
        skuItems = detail.sku_variants.map((variant) => ({
          product_id: variant.product_id,
          product_name:
            variant.product_name?.trim() || `Product #${variant.product_id}`,
          sku: variant.sku,
          title: variant.title,
          expected_quantity: variant.quantity,
          quantity: variant.quantity,
        }));
      } else if (detail?.products?.length) {
        skuItems = detail.products
          .filter((product) => Boolean(product.sku))
          .map((product) => ({
            product_id: product.product_id,
            product_name: product.product_name,
            sku: product.sku as string,
            title: product.product_name,
            expected_quantity: product.quantity,
            quantity: product.quantity,
          }));
      }

      runInAction(() => {
        const poWarehouseId = detail?.warehouse_id
          ? String(detail.warehouse_id)
          : undefined;
        const poWarehouseName = detail?.warehouse_identifier
          ? String(detail.warehouse_identifier)
          : poWarehouseId;

        if (poWarehouseId) {
          this.outwardRequestFormData = {
            ...this.outwardRequestFormData,
            sku_items: skuItems,
            warehouse_id: poWarehouseId,
            warehouse_name: poWarehouseName,
            quantity_details: [],
          };
        } else {
          this.outwardRequestFormData = {
            ...this.outwardRequestFormData,
            sku_items: skuItems,
            warehouse_id: undefined,
            warehouse_name: undefined,
            quantity_details: [],
          };
        }
      });

      return skuItems;
    } catch (error) {
      runInAction(() => {
        this.outwardRequestFormData = {
          ...this.outwardRequestFormData,
          sku_items: [],
        };
      });
      throw error;
    }
  };

  /**
   * Loads approved sample SIRs for an order (Sample Returned picker).
   */
  loadSampleReturnSirOptions = async (orderId: number) => {
    try {
      const options =
        await this.swageazyInventoryAPI.fetchSampleReturnSirs(orderId);
      runInAction(() => {
        this.sampleReturnSirOptions = options;
        if (options.length === 1) {
          if (this.sampleReturnRequestFormData === null) {
            this.sampleReturnRequestFormData =
              {} as SwageazyInventorySampleReturnRequestFormData;
          }
          this.sampleReturnRequestFormData = {
            ...this.sampleReturnRequestFormData,
            stock_issue_request_id: options[0]!.id,
          };
        }
      });
      return options;
    } catch (error) {
      runInAction(() => {
        this.sampleReturnSirOptions = [];
      });
      throw error;
    }
  };

  /**
   * Pre-fills Sample Returned popup from SIR detail (order + SIR locked).
   */
  initSampleReturnFromSir = async (
    orderId: number,
    stockIssueRequestId: number,
  ) => {
    runInAction(() => {
      this.sampleReturnRequestFormData = {
        order_id: orderId,
        stock_issue_request_id: stockIssueRequestId,
        sku_items: [],
      };
      this.sampleReturnSirOptions = [
        {
          id: stockIssueRequestId,
          order_id: orderId,
          total_issued: 0,
          total_returned: 0,
          total_pending: 0,
        },
      ];
    });

    await this.loadSampleReturnSkuItemsFromOrder(orderId, stockIssueRequestId);
  };

  /**
   * Loads SKU lines for sample return with expected / returned / pending qty.
   * When stockIssueRequestId is set, lines are scoped to that SIR.
   */
  loadSampleReturnSkuItemsFromOrder = async (
    orderId: number,
    stockIssueRequestId?: number,
  ) => {
    try {
      const lines = await this.swageazyInventoryAPI.fetchSampleReturnSkuLines(
        orderId,
        stockIssueRequestId,
      );

      const skuItems: SwageazyInventorySkuLineItem[] = (lines || [])
        .filter(
          (line) =>
            Boolean(String(line.sku ?? "").trim()) ||
            line.expected_quantity !== undefined,
        )
        .map((line) => {
          const productId = Number(line.product_id ?? line.id);
          const pendingQty =
            line.pending_quantity ??
            Math.max(
              Number(line.expected_quantity ?? 0) -
                Number(line.returned_quantity ?? line.quantity ?? 0),
              0,
            );

          return {
            product_id: productId,
            product_name:
              line.product_name?.trim() || `Product #${productId}`,
            sku: String(line.sku ?? "").trim(),
            title: String(line.sku ?? "").trim() || line.product_name || "",
            expected_quantity: line.expected_quantity,
            returned_quantity: line.returned_quantity ?? line.quantity,
            pending_quantity: pendingQty,
            selected: false,
            quantity: undefined,
          };
        });

      runInAction(() => {
        if (this.sampleReturnRequestFormData === null) {
          this.sampleReturnRequestFormData =
            {} as SwageazyInventorySampleReturnRequestFormData;
        }
        this.sampleReturnRequestFormData = {
          ...this.sampleReturnRequestFormData,
          sku_items: skuItems,
        };
      });

      return skuItems;
    } catch (error) {
      runInAction(() => {
        if (this.sampleReturnRequestFormData) {
          this.sampleReturnRequestFormData = {
            ...this.sampleReturnRequestFormData,
            sku_items: [],
          };
        }
      });
      throw error;
    }
  };

  updateInwardSkuItem = (
    sku: string,
    productId: number,
    updates: Partial<SwageazyInventorySkuLineItem>,
  ) => {
    runInAction(() => {
      this.inwardRequestFormData = {
        ...this.inwardRequestFormData,
        sku_items: (this.inwardRequestFormData.sku_items || []).map((item) =>
          item.sku === sku && item.product_id === productId
            ? { ...item, ...updates }
            : item,
        ),
      };
    });
  };

  updateOutwardSkuItem = (
    sku: string,
    productId: number,
    updates: Partial<SwageazyInventorySkuLineItem>,
  ) => {
    runInAction(() => {
      this.outwardRequestFormData = {
        ...this.outwardRequestFormData,
        // Changing requested qty / selection invalidates previously resolved boxes.
        quantity_details: [],
        sku_items: (this.outwardRequestFormData.sku_items || []).map((item) =>
          item.sku === sku && item.product_id === productId
            ? { ...item, ...updates }
            : item,
        ),
      };
    });
  };

  setOutwardSkuItemsSelected = (
    items: Array<{ sku: string; productId: number }>,
    selected: boolean,
  ) => {
    runInAction(() => {
      const keys = new Set(
        items.map((item) => `${item.productId}::${item.sku}`),
      );
      this.outwardRequestFormData = {
        ...this.outwardRequestFormData,
        quantity_details: [],
        sku_items: (this.outwardRequestFormData.sku_items || []).map((item) =>
          keys.has(`${item.product_id}::${item.sku}`)
            ? { ...item, selected }
            : item,
        ),
      };
    });
  };

  setSampleReturnSkuItemsSelected = (
    items: Array<{ sku: string; productId: number }>,
    selected: boolean,
  ) => {
    runInAction(() => {
      if (!this.sampleReturnRequestFormData) return;
      const keys = new Set(
        items.map((item) => `${item.productId}::${item.sku}`),
      );
      this.sampleReturnRequestFormData = {
        ...this.sampleReturnRequestFormData,
        sku_items: (this.sampleReturnRequestFormData.sku_items || []).map(
          (item) => {
            if (!keys.has(`${item.product_id}::${item.sku}`)) {
              return item;
            }
            return {
              ...item,
              selected,
              quantity: selected ? item.quantity : undefined,
            };
          },
        ),
      };
    });
  };

  clearOutwardQuantityDetails = () => {
    runInAction(() => {
      this.outwardRequestFormData = {
        ...this.outwardRequestFormData,
        quantity_details: [],
      };
    });
  };

  /**
   * Updates a resolved debit line qty. Quantity can only be lowered
   * (or cleared), never raised above the resolve-boxes allocation.
   */
  updateOutwardQuantityDetail = (index: number, quantity?: number) => {
    runInAction(() => {
      const details = [...(this.outwardRequestFormData.quantity_details || [])];
      if (index < 0 || index >= details.length) return;

      const current = details[index];
      const maxQty = Number(current.max_quantity ?? current.quantity) || 0;
      let nextQty = quantity;

      if (nextQty === undefined || Number.isNaN(nextQty)) {
        nextQty = undefined;
      } else if (nextQty < 0) {
        nextQty = 0;
      } else if (nextQty > maxQty) {
        nextQty = maxQty;
      }

      details[index] = {
        ...current,
        quantity: nextQty === undefined ? 0 : nextQty,
      };

      this.outwardRequestFormData = {
        ...this.outwardRequestFormData,
        quantity_details: details,
      };
    });
  };

  updateSampleReturnSkuItem = (
    sku: string,
    productId: number,
    updates: Partial<SwageazyInventorySkuLineItem>,
  ) => {
    runInAction(() => {
      if (!this.sampleReturnRequestFormData) return;
      this.sampleReturnRequestFormData = {
        ...this.sampleReturnRequestFormData,
        sku_items: (this.sampleReturnRequestFormData.sku_items || []).map(
          (item) =>
            item.sku === sku && item.product_id === productId
              ? { ...item, ...updates }
              : item,
        ),
      };
    });
  };

  getPurchaseRequestDetailsByOrderIdAndProductId = async (
    orderId: number,
    productId: number,
  ) => {
    try {
      const response =
        await this.swageazyInventoryAPI.getPurchaseRequestDetailsByOrderIdAndProductId(
          orderId,
          productId,
        );
      runInAction(() => {
        this.purchaseRequestDetailsList = Array.isArray(response) ? response : [];
        if (this.purchaseRequestDetailsList.length === 1) {
          this.purchaseRequestDetail = this.purchaseRequestDetailsList[0];
        } else {
          this.purchaseRequestDetail = null;
        }
      });
    } catch (error: any) {
      throw error;
    }
  };

  selectPurchaseRequestDetail = (purchaseRequestId: number | null) => {
    runInAction(() => {
      if (!purchaseRequestId) {
        this.purchaseRequestDetail = null;
        return;
      }

      this.purchaseRequestDetail =
        this.purchaseRequestDetailsList.find(
          (detail) => detail.id === purchaseRequestId,
        ) || null;
    });
  };

  clearPurchaseRequestDetail = () => {
    runInAction(() => {
      this.purchaseRequestDetail = null;
      this.purchaseRequestDetailsList = [];
    });
  };

  //set section

  setPurchaseRequestFormData = (data: PurchaseRequestBody) => {
    runInAction(() => {
      this.purchaseRequestFormData = data;
    });
  };

  setInwardRequestFormData = (data: SwageazyInventoryInwardRequestFormData) => {
    runInAction(() => {
      this.inwardRequestFormData = {
        ...this.inwardRequestFormData,
        ...data,
      };
    });
  };

  setSampleReturnRequestFormData = (
    data: Partial<SwageazyInventorySampleReturnRequestFormData>,
  ) => {
    runInAction(() => {
      if (this.sampleReturnRequestFormData === null) {
        this.sampleReturnRequestFormData =
          {} as SwageazyInventorySampleReturnRequestFormData;
      }
      this.sampleReturnRequestFormData = {
        ...this.sampleReturnRequestFormData,
        ...data,
      };
    });
  };

  setOutwardRequestFormData = (
    data: SwageazyInventoryOutwardRequestFormData,
  ) => {
    runInAction(() => {
      this.outwardRequestFormData = {
        ...this.outwardRequestFormData,
        ...data,
      };
    });
  };

  setBoxTransferFormData(data: Partial<SwageazyInventoryBoxTransferFormData>) {
    runInAction(() => {
      if (this.boxTransferFormData == null) {
        this.boxTransferFormData = {};
      }
      if (!Array.isArray(this.warehouseBoxes)) {
        this.warehouseBoxes = [];
      }
      this.boxTransferFormData = {
        ...this.boxTransferFormData,
        ...data,
      };
    });
  }

  resetBoxTransferFormData() {
    runInAction(() => {
      this.boxTransferLoadSeq += 1;
      this.boxTransferFormData = {};
      this.warehouseBoxes = [];
      this.isBoxTransferLoading = false;
    });
  }

  ensureBoxTransferState() {
    runInAction(() => {
      if (this.boxTransferFormData == null) {
        this.boxTransferFormData = {};
      }
      if (!Array.isArray(this.warehouseBoxes)) {
        this.warehouseBoxes = [];
      }
      if (typeof this.isBoxTransferLoading !== "boolean") {
        this.isBoxTransferLoading = false;
      }
      if (
        this.popupState &&
        typeof this.popupState.openBoxTransferPopup !== "boolean"
      ) {
        this.popupState.openBoxTransferPopup = false;
      }
    });
  }

  async loadWarehouseBoxes(warehouseId: string): Promise<void> {
    if (!warehouseId) {
      runInAction(() => {
        this.warehouseBoxes = [];
      });
      return;
    }

    const seq = ++this.boxTransferLoadSeq;

    runInAction(() => {
      this.isBoxTransferLoading = true;
    });
    try {
      const boxes =
        await this.swageazyInventoryAPI.listWarehouseBoxes(warehouseId);
      runInAction(() => {
        if (seq !== this.boxTransferLoadSeq) return;
        if (!this.popupState?.openBoxTransferPopup) {
          this.isBoxTransferLoading = false;
          return;
        }
        this.warehouseBoxes = boxes || [];
        this.isBoxTransferLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        if (seq !== this.boxTransferLoadSeq) return;
        this.warehouseBoxes = [];
        this.isBoxTransferLoading = false;
      });
      throw error;
    }
  }

  async loadBoxTransferStock(
    sourceBoxIdOverride?: string,
    options?: { selectSku?: string; selectProductId?: number },
  ): Promise<void> {
    const warehouseId = this.boxTransferFormData.warehouse_id;
    const sourceBoxId =
      sourceBoxIdOverride?.trim() ||
      this.boxTransferFormData.source_box_id?.trim();
    if (!warehouseId || !sourceBoxId) {
      throw new Error("Warehouse and source box are required to load stock.");
    }

    const seq = ++this.boxTransferLoadSeq;

    runInAction(() => {
      this.isBoxTransferLoading = true;
    });

    try {
      const stock = await this.swageazyInventoryAPI.getBoxStock(
        sourceBoxId,
        warehouseId,
      );
      const selectSku = options?.selectSku?.trim().toUpperCase();
      const selectProductId = options?.selectProductId;
      const isSingleSkuPrefill =
        Boolean(selectSku) && Boolean(selectProductId);

      const mappedLines = (stock || []).map((line: BoxTransferStockLine) => {
        const isPrefillMatch =
          isSingleSkuPrefill &&
          line.product_id === selectProductId &&
          String(line.sku || "")
            .trim()
            .toUpperCase() === selectSku;

        return {
          ...line,
          selected: isSingleSkuPrefill ? isPrefillMatch : false,
          transfer_quantity: line.quantity,
        };
      });

      // Variant-row shortcut: only keep the one SKU in the form.
      const stock_lines = isSingleSkuPrefill
        ? mappedLines.filter((line) => line.selected)
        : mappedLines;

      runInAction(() => {
        if (seq !== this.boxTransferLoadSeq) return;
        if (!this.popupState?.openBoxTransferPopup) {
          this.isBoxTransferLoading = false;
          return;
        }

        this.boxTransferFormData = {
          ...this.boxTransferFormData,
          source_box_id: sourceBoxId,
          stock_lines,
        };
        this.isBoxTransferLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        if (seq !== this.boxTransferLoadSeq) return;
        this.isBoxTransferLoading = false;
        this.boxTransferFormData = {
          ...this.boxTransferFormData,
          stock_lines: [],
        };
      });
      throw error;
    }
  }

  /**
   * Blank Actions-menu entry: clear any prior prefill and open popup.
   */
  openBoxTransferBlank() {
    this.ensureBoxTransferState();
    this.resetBoxTransferFormData();
    this.managePopup("openBoxTransferPopup", "open");
  }

  /**
   * Variants-row shortcut: prefill warehouse + source box, load stock,
   * select the clicked SKU, then open transfer popup.
   */
  async openBoxTransferFromVariant(
    prefill: BoxTransferVariantPrefill,
  ): Promise<void> {
    this.ensureBoxTransferState();

    const productId = Number(prefill.product_id);
    const warehouseId = String(prefill.warehouse_id || "").trim();
    const boxId = String(prefill.box_id || "")
      .trim()
      .toUpperCase();
    const sku = String(prefill.sku || "")
      .trim()
      .toUpperCase();
    const hintQty = Number(prefill.quantity ?? 0);

    if (!productId || Number.isNaN(productId)) {
      throw new Error("Valid product is required for box transfer.");
    }
    if (!warehouseId) {
      throw new Error("Warehouse is required for box transfer.");
    }
    if (!boxId || !/^B\d{5}$/i.test(boxId)) {
      throw new Error(`Invalid box id '${boxId}'. Expected format B#####.`);
    }
    if (!sku) {
      throw new Error("SKU is required for box transfer.");
    }
    if (!(hintQty > 0)) {
      throw new Error("No transferable quantity available for this variant.");
    }

    this.resetBoxTransferFormData();
    this.setBoxTransferFormData({
      warehouse_id: warehouseId,
      warehouse_name: warehouseId,
      source_box_id: boxId,
      prefill_sku: sku,
      prefill_product_id: productId,
    });

    // Keep variants/stock dialog open; transfer opens above it.
    this.managePopup("openBoxTransferPopup", "open");

    try {
      await this.loadWarehouseBoxes(warehouseId);
      if (!this.popupState.openBoxTransferPopup) {
        return;
      }

      await this.loadBoxTransferStock(boxId, {
        selectSku: sku,
        selectProductId: productId,
      });
      if (!this.popupState.openBoxTransferPopup) {
        return;
      }

      const matched = (this.boxTransferFormData.stock_lines || []).find(
        (line) =>
          line.product_id === productId &&
          String(line.sku || "")
            .trim()
            .toUpperCase() === sku,
      );

      if (!matched || !(Number(matched.quantity) > 0)) {
        this.managePopup("openBoxTransferPopup", "close");
        this.resetBoxTransferFormData();
        throw new Error(
          `SKU '${sku}' is no longer available in box '${boxId}'. Refresh stock and try again.`,
        );
      }
    } catch (error) {
      // Avoid leaving a locked, empty transfer dialog after load failures.
      if (this.popupState.openBoxTransferPopup) {
        const hasStock = (this.boxTransferFormData.stock_lines || []).some(
          (line) =>
            line.product_id === productId &&
            String(line.sku || "")
              .trim()
              .toUpperCase() === sku &&
            Number(line.quantity) > 0,
        );
        if (!hasStock) {
          this.managePopup("openBoxTransferPopup", "close");
          this.resetBoxTransferFormData();
        }
      }
      throw error;
    }
  }

  async createBoxTransfer(): Promise<APIResponse> {
    if (this.isBoxTransferLoading) {
      throw new Error("A box transfer is already in progress.");
    }

    runInAction(() => {
      this.isBoxTransferLoading = true;
    });

    try {
      const form = this.boxTransferFormData;
      if (!form.warehouse_id || !form.source_box_id || !form.dest_box_id) {
        throw new Error(
          "Warehouse, source box, and destination box are required.",
        );
      }

      const lines = (form.stock_lines || [])
        .filter((line) => line.selected && (line.transfer_quantity || 0) > 0)
        .map((line) => ({
          product_id: line.product_id,
          sku: line.sku,
          quantity: Number(line.transfer_quantity),
          available: Number(line.quantity),
        }));

      if (lines.length === 0) {
        throw new Error("Select at least one SKU with transfer quantity.");
      }

      const prefillSku = form.prefill_sku?.trim().toUpperCase();
      const prefillProductId = form.prefill_product_id;
      if (prefillSku && prefillProductId) {
        if (lines.length !== 1) {
          throw new Error(
            "Variant transfer allows only the selected SKU. Reopen transfer from the variant row.",
          );
        }
        const only = lines[0];
        if (
          only.product_id !== prefillProductId ||
          String(only.sku || "")
            .trim()
            .toUpperCase() !== prefillSku
        ) {
          throw new Error(
            `Variant transfer is locked to SKU '${prefillSku}'. Reopen transfer from the variant row.`,
          );
        }
      }

      const overQty = lines.find(
        (line) =>
          !Number.isFinite(line.quantity) ||
          line.quantity <= 0 ||
          line.quantity > line.available,
      );
      if (overQty) {
        throw new Error(
          `Transfer qty for SKU '${overQty.sku}' must be between 1 and ${overQty.available}.`,
        );
      }

      if (
        form.source_box_id.trim().toUpperCase() ===
        form.dest_box_id.trim().toUpperCase()
      ) {
        throw new Error("Source and destination boxes must be different.");
      }

      const payload: BoxTransferRequest = {
        warehouse_id: form.warehouse_id,
        source_box_id: form.source_box_id.trim().toUpperCase(),
        dest_box_id: form.dest_box_id.trim().toUpperCase(),
        lines: lines.map(({ product_id, sku, quantity }) => ({
          product_id,
          sku,
          quantity,
        })),
      };

      if (form.reason?.trim()) {
        payload.reason = form.reason.trim();
      }

      return await this.swageazyInventoryAPI.createBoxTransfer(payload);
    } finally {
      runInAction(() => {
        this.isBoxTransferLoading = false;
      });
    }
  }

  setRackTransferFormData(
    data: Partial<SwageazyInventoryRackTransferFormData>,
  ) {
    runInAction(() => {
      this.rackTransferFormData = {
        ...this.rackTransferFormData,
        ...data,
      };
    });
  }

  resetRackTransferFormData() {
    runInAction(() => {
      this.rackTransferLoadSeq += 1;
      this.rackTransferFormData = {};
      this.isRackTransferLoading = false;
      this.isRackTransferLookupLoading = false;
    });
  }

  clearRackTransferLookups() {
    runInAction(() => {
      this.warehouseRacks = [];
    });
  }

  openRackTransferBlank() {
    this.resetRackTransferFormData();
    this.managePopup("openRackTransferPopup", "open");
  }

  /**
   * Variants-row shortcut: lock warehouse, source rack, and the clicked box.
   */
  async openRackTransferFromVariant(
    prefill: RackTransferVariantPrefill,
  ): Promise<void> {
    const warehouseId = String(prefill.warehouse_id || "").trim();
    const sourceRackId = String(prefill.source_rack_id || "")
      .trim()
      .toUpperCase();
    const boxId = String(prefill.box_id || "")
      .trim()
      .toUpperCase();

    if (!warehouseId) {
      throw new Error("Warehouse is required for rack transfer.");
    }
    if (!sourceRackId) {
      throw new Error("This box is not on a rack.");
    }
    if (!boxId || !/^B\d{5}$/i.test(boxId)) {
      throw new Error(`Invalid box id '${boxId}'. Expected format B#####.`);
    }

    this.resetRackTransferFormData();
    this.setRackTransferFormData({
      warehouse_id: warehouseId,
      warehouse_name: warehouseId,
      source_rack_id: sourceRackId,
      prefill_box_id: boxId,
      boxes: [{ id: boxId, current_rack: sourceRackId, selected: true }],
    });
    this.managePopup("openRackTransferPopup", "open");

    const seqAtStart = this.rackTransferLoadSeq;
    try {
      const applied = await this.loadRackTransferWarehouse(warehouseId);
      if (!applied || !this.popupState.openRackTransferPopup) {
        return;
      }

      const matched = (this.rackTransferFormData.boxes || []).some(
        (box) => box.id.trim().toUpperCase() === boxId,
      );
      if (!matched) {
        this.managePopup("openRackTransferPopup", "close");
        this.resetRackTransferFormData();
        throw new Error(
          `Box '${boxId}' is not on rack '${sourceRackId}'. Refresh and try again.`,
        );
      }
    } catch (error) {
      if (
        this.rackTransferLoadSeq === seqAtStart + 1 &&
        this.popupState.openRackTransferPopup &&
        this.rackTransferFormData.prefill_box_id === boxId
      ) {
        this.managePopup("openRackTransferPopup", "close");
        this.resetRackTransferFormData();
      }
      throw error;
    }
  }

  private boxesOnRack(rackId?: string) {
    if (!rackId) return [];
    const rack = rackId.trim().toUpperCase();
    const lockedBoxId = this.rackTransferFormData.prefill_box_id
      ?.trim()
      .toUpperCase();
    const rows = (this.warehouseBoxes || [])
      .filter(
        (box) => String(box.current_rack || "").trim().toUpperCase() === rack,
      )
      .map((box) => ({
        id: String(box.id),
        current_rack: box.current_rack,
        selected: lockedBoxId
          ? String(box.id).trim().toUpperCase() === lockedBoxId
          : false,
      }));
    if (!lockedBoxId) return rows;
    return rows.filter((box) => box.id.trim().toUpperCase() === lockedBoxId);
  }

  async loadRackTransferWarehouse(warehouseId: string): Promise<boolean> {
    const seq = ++this.rackTransferLoadSeq;
    runInAction(() => {
      this.isRackTransferLookupLoading = true;
    });
    try {
      const [racks, boxes] = await Promise.all([
        this.swageazyInventoryAPI.listWarehouseRacks(warehouseId),
        this.swageazyInventoryAPI.listWarehouseBoxes(warehouseId),
      ]);
      let applied = false;
      runInAction(() => {
        if (seq !== this.rackTransferLoadSeq) return;
        if (!this.popupState?.openRackTransferPopup) return;
        if (this.rackTransferFormData.warehouse_id !== warehouseId) return;
        this.warehouseRacks = racks || [];
        this.warehouseBoxes = boxes || [];
        this.rackTransferFormData = {
          ...this.rackTransferFormData,
          boxes: this.boxesOnRack(this.rackTransferFormData.source_rack_id),
        };
        applied = true;
      });
      return applied;
    } finally {
      runInAction(() => {
        if (seq === this.rackTransferLoadSeq) {
          this.isRackTransferLookupLoading = false;
        }
      });
    }
  }

  selectRackTransferSource(rackId?: string) {
    if (this.rackTransferFormData.prefill_box_id) return;
    runInAction(() => {
      this.rackTransferFormData = {
        ...this.rackTransferFormData,
        source_rack_id: rackId,
        boxes: this.boxesOnRack(rackId),
      };
    });
  }

  toggleRackTransferBox(boxId: string, selected: boolean) {
    if (this.rackTransferFormData.prefill_box_id) return;
    runInAction(() => {
      this.rackTransferFormData = {
        ...this.rackTransferFormData,
        boxes: (this.rackTransferFormData.boxes || []).map((box) =>
          box.id === boxId ? { ...box, selected } : box,
        ),
      };
    });
  }

  toggleAllRackTransferBoxes(selected: boolean) {
    if (this.rackTransferFormData.prefill_box_id) return;
    runInAction(() => {
      this.rackTransferFormData = {
        ...this.rackTransferFormData,
        boxes: (this.rackTransferFormData.boxes || []).map((box) => ({
          ...box,
          selected,
        })),
      };
    });
  }

  async createRack(): Promise<CreatedRackResult> {
    const warehouseId = this.rackTransferFormData.warehouse_id;
    if (!warehouseId) {
      throw new Error("Select a warehouse first.");
    }
    const response = await this.swageazyInventoryAPI.createWarehouseRack({
      warehouse_id: warehouseId,
    });
    const created = response.result as CreatedRackResult;
    if (!created?.id) {
      throw new Error("Failed to generate rack.");
    }
    runInAction(() => {
      const exists = this.warehouseRacks.some(
        (rack) => rack.id.toUpperCase() === created.id.toUpperCase(),
      );
      this.warehouseRacks = exists
        ? this.warehouseRacks
        : [
            ...this.warehouseRacks,
            { id: created.id, warehouse_id: created.warehouse_id },
          ];
      this.rackTransferFormData = {
        ...this.rackTransferFormData,
        dest_rack_id: created.id,
      };
    });
    return created;
  }

  async createRackTransfer(): Promise<APIResponse> {
    if (this.isRackTransferLoading) {
      throw new Error("A rack transfer is already in progress.");
    }
    runInAction(() => {
      this.isRackTransferLoading = true;
    });
    try {
      const form = this.rackTransferFormData;
      if (!form.warehouse_id || !form.source_rack_id || !form.dest_rack_id) {
        throw new Error(
          "Warehouse, source rack, and destination rack are required.",
        );
      }
      const boxIds = (form.boxes || [])
        .filter((box) => box.selected)
        .map((box) => box.id.trim().toUpperCase());
      if (boxIds.length === 0) {
        throw new Error("Select at least one box to move.");
      }
      const lockedBoxId = form.prefill_box_id?.trim().toUpperCase();
      if (lockedBoxId && (boxIds.length !== 1 || boxIds[0] !== lockedBoxId)) {
        throw new Error(
          `This transfer is locked to box '${lockedBoxId}'. Reopen it from the variant row.`,
        );
      }
      if (
        form.source_rack_id.trim().toUpperCase() ===
        form.dest_rack_id.trim().toUpperCase()
      ) {
        throw new Error("Source and destination racks must be different.");
      }
      const payload: RackTransferRequest = {
        warehouse_id: form.warehouse_id,
        source_rack_id: form.source_rack_id.trim().toUpperCase(),
        dest_rack_id: form.dest_rack_id.trim().toUpperCase(),
        box_ids: boxIds,
      };
      if (form.reason?.trim()) payload.reason = form.reason.trim();
      return await this.swageazyInventoryAPI.createRackTransfer(payload);
    } finally {
      runInAction(() => {
        this.isRackTransferLoading = false;
      });
    }
  }

  setProductSearchText = (text: string) => {
    runInAction(() => {
      this.productSearchText = text || "";
    });
  };

  //reset section

  setSelectedSkuVariants = (
    productId: number,
    variants: PurchaseRequestSkuVariant[],
  ) => {
    runInAction(() => {
      this.selectedSkuVariants.set(productId, variants);
    });
  };

  resetCreatePurchaseRequestState = () => {
    runInAction(() => {
      this.products = [];
      this.purchaseRequestProducts = [];
      this.selectedProductVariants.clear();
      this.selectedSkuVariants.clear();
      this.prVariantStockShortages = [];
      this.isValidatingPrInventoryStock = false;
      this.isPrInventoryResolved = false;
      this.purchaseRequestFormData = {
        emails: [],
      };
    });
  };

  resetSampleReturnRequestFormData = () => {
    runInAction(() => {
      this.sampleReturnRequestFormData = null;
      this.sampleReturnSirOptions = [];
      this.orderProducts = [];
      this.orderSearchResults = [];
      this.purchaseRequestDetail = null;
      this.purchaseRequestDetailsList = [];
    });
  };

  resetInwardRequestFormData = () => {
    runInAction(() => {
      this.inwardRequestFormData = {};
      this.poProducts = [];
      this.poSearchResults = [];
      this.availableVariantOptions = {};
      this.purchaseRequestDetail = null;
      this.purchaseRequestDetailsList = [];
    });
  };

  resetOutwardRequestFormData = () => {
    runInAction(() => {
      this.outwardRequestFormData = {};
      this.poProducts = [];
      this.poSearchResults = [];
      this.purchaseRequestDetail = null;
      this.purchaseRequestDetailsList = [];
      this.blockStockDetailsResponce = null;
      this.productStockDetails = null;
    });
  };
}
